import { Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppService, BusinessService, UpdateService } from 'briteatlib';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PaymentLogosComponent } from '../payment-logos/payment-logos.component';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'brt-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, PaymentLogosComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  host: { class: 'page-footer' }
})
export class FooterComponent {
  // Custom copyright line for the active brand HQ, when set.
  copyright: string | null = null;
  version = environment.version;
  refreshing = false;

  constructor(public businessService: BusinessService, appService: AppService, private updateService: UpdateService) {
    appService.activeHq$.pipe(takeUntilDestroyed()).subscribe(hq => this.copyright = hq?.Copyright || null);
  }

  async refreshApp() {
    if (this.refreshing) return;
    this.refreshing = true;
    await this.updateService.refreshApp();
  }

}
